import PropTypes from 'prop-types'
import { useState } from 'react'
import { Trophy, Lock, Play } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../ModalContainer/ModelContainer'
import API from '../../../api/api'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'

const PromoPopUp = ({ isVisible, onClose, buildingId }) => {
  const { t } = useTranslation(['chat'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)

  const requestFeature = () => {
    if (isLoading) return
    setIsLoading(true)
    API.sendUpsellingMessage({ type: 'escalationsCallSchedule' }, buildingId)
      .then(() => displaySnackbar(t('chat:promoPopUp.requestSuccess')))
      .catch(() => displaySnackbar(t('chat:promoPopUp.requestError'), true))
      .finally(() => setIsLoading(false))
  }

  return (
    <ModalContainer
      onClose={onClose}
      isVisible={isVisible}
      headerTitle={t('chat:promoPopUp.title')}
      headerIcon={<Trophy size={24} />}
    >
      <div className="promo-popup">
        <div className="promo-popup__info">
          <Lock size={17} weight="fill" />
          {t('chat:promoPopUp.featureLocked')}
        </div>
        <div className="promo-popup__description">
          <h3 className="promo-popup__title">{t('chat:promoPopUp.upgradeTitle')}</h3>
          <p className="promo-popup__text">{t('chat:promoPopUp.description')}</p>
        </div>
        <div className="promo-popup__video">
          <div className="promo-popup__play">
            <Play size={20} />
          </div>
        </div>
        <button
          onClick={requestFeature}
          className={`button button-black ${isLoading ? 'is-loading' : ''}`}
          disabled={isLoading}
        >
          {t('chat:promoPopUp.talkToAccountManager')}
        </button>
      </div>
    </ModalContainer>
  )
}

PromoPopUp.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  buildingId: PropTypes.number,
}

export default PromoPopUp
